<div class="trade-card"
     data-element="trade-card"
     [class.previewed]="this.previewed"
     [class.expanded]="this.expanded">

  <!-- Collapsed face (always visible; click toggles the detail): APG-anatomy diagonal score
       in front (only when the skill provided one — display-only), trade name top-left with the
       legs + quantities summary (WI-8 — date-line weight, "no more distinctive than the date
       text") pinned to the card's BOTTOM line (CR-20260715-002 — level with the Max Risk row;
       it had sat directly under the name), then the right-side stack in the APG card's order
       (BF-4): price / bound expiration / Max Risk category. No sample chip — mock provenance
       lives in the NAME only (A4). CR-20260715-003: the legs line breaks only at leg-unit
       boundaries (NBSP — see legsText) and is capped at two lines (scss), so the title carries
       the full text as the overflow safety net. -->
  <div class="card-header" data-element="card-header" (click)="this.toggleExpanded()">

    <span class="score" data-element="score-indicator" *ngIf="this.hasScore">
      <span class="score-value" data-element="score-value">{{ this.scoreText }}</span>
      <span class="score-slash">/</span>
      <span class="score-scale" data-element="score-scale">100</span>
    </span>

    <span class="card-main" data-element="card-main">
      <span class="trade-name" data-element="trade-name" [title]="this.tradeName">{{ this.tradeName }}</span>
      <span class="card-legs" data-element="trade-legs-line" *ngIf="this.legsText" [title]="this.legsText">{{ this.legsText }}</span>
    </span>

    <span class="card-right">
      <span class="price" data-element="trade-price"
            [class.credit]="this.isCredit"
            [class.debit]="this.isDebit">{{ this.priceText }}</span>
      <span class="card-exp" data-element="trade-expiration" *ngIf="this.expirationText">{{ this.expirationText }}</span>
      <span class="max-risk" data-element="trade-max-risk" *ngIf="this.maxRiskText"><span class="mr-label">Max Risk</span><span class="dot"> · </span>{{ this.maxRiskText }}</span>
      <!-- Both CR: the family tag of a mixed run's candidate (skill-tagged; absent on
           single-family runs, so their cards render exactly as before). On a follow-through
           it sits where the (deliberately absent) Max Risk line would be. -->
      <span class="card-family" data-element="trade-family" *ngIf="this.familyText"
            [class.family-range]="this.isRangeFamily"
            [class.family-ft]="!this.isRangeFamily">{{ this.familyText }}</span>
    </span>
  </div>

  <!-- Expanded detail (BF-4): the legs table — the OPG strategy-builder structure rendered
       read-only (strike-DESC rows interleaved with inter-leg distance rows; the distance
       value renders in the STRIKE column, Options-Pricing-Pad style — meeting 2026-07-15;
       Exp. Offset column only when a leg carries one) — + the ONE full-width
       Preview↔Un-Preview action. NO Review button (§10).

       WI-18/A10: a fourth PRICE column (each leg's live signed price at its strike) and a
       "Total (Order Price)" footer — the Hedge CoPilot solution card's own anatomy, which is
       where this table came from. The total is the ORDER price (net / HCF, no Default-Qty
       normalization); the LEDGER price is the unlabelled headline in the card face above,
       because that is the one that has to agree with the grid. Two different prices on purpose. -->
  <div class="card-detail" *ngIf="this.expanded">

    <table class="legs" data-element="trade-legs">
      <thead>
        <tr>
          <th>Side</th>
          <th>Qty</th>
          <th>Strike</th>
          <th>Price</th>
          <th *ngIf="this.hasLegOffsets">Exp. Offset</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of this.legRows">
          <tr *ngIf="row.kind === 'leg'" class="leg-row" data-element="trade-leg-row">
            <td class="side"
                [class.buy]="row.side === 'Buy'"
                [class.sell]="row.side === 'Sell'">{{ row.side }}</td>
            <td class="num">{{ row.qty }}</td>
            <td class="num">{{ row.strike }}</td>
            <td class="num price" data-element="trade-leg-price"
                [class.credit]="this.isCreditPrice(row.price)"
                [class.debit]="this.isDebitPrice(row.price)">{{ this.legPriceText(row) }}</td>
            <td class="num offset" *ngIf="this.hasLegOffsets">{{ row.offsetText }}</td>
          </tr>
          <tr *ngIf="row.kind === 'width'" class="width-row" data-element="trade-width-row">
            <td></td>
            <td></td>
            <td class="num width">{{ row.width }}</td>
            <td></td>
            <td *ngIf="this.hasLegOffsets"></td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr class="total-row" data-element="trade-total-row">
          <td colspan="3">Total (Order Price)</td>
          <td class="num price" data-element="trade-total-price"
              [class.credit]="this.isCreditPrice(this.orderPrice)"
              [class.debit]="this.isDebitPrice(this.orderPrice)">{{ this.orderPriceText }}</td>
          <td *ngIf="this.hasLegOffsets"></td>
        </tr>
      </tfoot>
    </table>

    <div class="card-actions" data-element="card-actions" [class.unpreview]="this.previewed">
      <dx-button [text]="this.previewLabel" data-element="btn-preview"
                 [disabled]="this.previewBlockedReason !== null" [hint]="this.previewBlockedReason || ''"
                 (onClick)="this.onPreviewClick()" width="100%"></dx-button>
    </div>

    <!-- M8 (CR-20260720-001): compliance disclaimer, directly UNDER the Preview action so it is on
         screen before the trade is loaded (owner: "should show up before the user hits a preview").
         Expanded-detail only — deliberately absent from the collapsed face (owner ruling). The
         text is the SHARED constant (copilot-shared/copilot-disclaimer.ts) — one source of truth
         for all five Co-Pilot render sites, owner-sanctioned 2026-07-20 as the second exception to
         the family rule. Interpolated, so the constant must stay markup-free. -->
    <div class="card-disclaimer" data-element="card-disclaimer" *ngIf="this.disclaimerEnabled"><span class="disclaimer-label">{{ this.disclaimer.label }}</span>: {{ this.disclaimer.text }}</div>

  </div>

</div>
